import moment from 'moment';

export const renderApprovalHistory = (approvalHistory) => {
	return approvalHistory.map((item, index) => (
		<div key={index}>
			<p>Fecha: {moment(item?.created_at * 1000).format('DD/MM/YYYY HH:mm:ss')}</p>
			<p>Responsable: {item.qf_email}</p>
			<p>Motivo de aprobación: {item.observation}.</p>
			<span>--------------------------------------------------------------------</span>
		</div>
	));
};
